export type routesTypes = {
    id: string;
    type:string;
    title : string;
    next : string;
    continue: string;
}

const routes: routesTypes[] = [
    {
        id : "phq-9",
        type:"PHQ-9",
        title: "PHQ-9",
        next : "questionnaire/gad-7",
        continue: "GAD-7"

    },
     {
        id : "gad-7",
        type:"GAD-7",
        title: "GAD-7",
        next : "",
       continue: ""
    }
]

export default routes;
